let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5O9CW")).then(() => parcelRequire('bv20m'));